export const ATTENDANCE_UPLOAD = 'ATTENDANCE_UPLOAD'
export const GET_TODAY_ATTENDANCE = 'GET_TODAY_ATTENDANCE'
export const GET_STD_MOTNTHWISE_ATTENDANCE = 'GET_STD_MOTNTHWISE_ATTENDANCE'

export const ATTENDANCE_SETTING = 'ATTENDANCE_SETTING'
export const UPDATE_ATTENDANCE_SETTING = 'UPDATE_ATTENDANCE_SETTING'

export const ATTENDANCE_ADD_ATTENDANCE_REMARKS = 'ATTENDANCE_ADD_ATTENDANCE_REMARKS'
export const MARK_USER_ATTENDANCE = 'MARK_USER_ATTENDANCE'
export const UNMARK_USER_ATTENDANCE = 'UNMARK_USER_ATTENDANCE'
export const ATTENDANCE_CHECKOUT_DEAILS = 'UNMARK_USER_ATTENDANCE'
export const UPDATE_USER_ATTENDANCE = 'UPDATE_USER_ATTENDANCE'
export const ATTENDANCE_SETTINGS_BY_BRANCH = 'ATTENDANCE_SETTINGS_BY_BRANCH'
export const GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT =
  'GENERATE_TEACHER_STAFF_INDIVIDUAL_ATTENDANCE_REPORT'
export const GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT =
  'GENERATE_TEACHER_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT'
export const GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT =
  'GENERATE_TEACHER_SUBJECT_COMBINE_ATTENDANCE_REPORT'
export const GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT =
  'GENERATE_TEACHER_SUBJECT_ROSTER_ATTENDANCE_REPORT'
export const GENERATE_TEACHER_STAFF_COMBINE_ATTENDANCE_REPORT =
  'GENERATE_INDIVIDUAL_ATTENDANCE_REPORT'
export const GENERATE_TEACHER_STAFF_MONTHLY_COMBINE_ATTENDANCE_REPORT =
  'GENERATE_TEACHER_STAFF_MONTHLY_COMBINE_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT =
  'GENERATE_STUDENT_SUBJECT_INDIVIDUAL_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT =
  'GENERATE_STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT =
  'GENERATE_STUDENT_SUBJECT_MONTHLY_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT =
  'GENERATE_STUDENT_INDIVIDUAL_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT =
  'GENERATE_STUDENT_COMBINE_ATTENDANCE_REPORT'
export const GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT = 'GENERATE_STUDENT_CLASSWISE_SUMMARY_REPORT'
export const GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT =
  'GENERATE_STUDENT_SUBJECTWISE_SUMMARY_REPORT'
export const GENERATE_STUDENT_MONTHWISE_REPORT = 'GENERATE_STUDENT_MONTHWISE_REPORT'
export const GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT = 'GENERATE_STUDENT_SUBJECT_MONTHLY_REPORT'
export const GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT =
  'GENERATE_DATEWISE_DETAILED_ATTENDANCE_REPORT'
export const ATTENDANCE_SETTING_CREATE = 'ATTENDANCE_SETTING_CREATE'
export const SEND_ATTENDANCE_WARNING = 'SEND_ATTENDANCE_WARNING'
